export const userPermissionCheck = (
  loginAccount: Record<string, any>,
  fcName: string,
  isMute: boolean = false
) => {
  if (loginAccount?.account_id === -1) {
    return true;
  }
  if (!loginAccount?.user_auth_passed) {
    !isMute &&
      console.warn('permission check user_auth_passed failed', loginAccount);
    return false;
  }
  const portal = loginAccount?.portals?.find(
    (obj: Record<string, any>) => obj?.app_name === fcName
  );
  if (!portal) {
    !isMute &&
      console.warn('permission check portal not found', loginAccount, fcName);
    return false;
  }
  // patch of 0172 for portal.permission_profile is null
  const access_type =
    portal?.user_role ||
    portal?.user_permission ||
    portal?.permission_profile?.access_type ||
    '';

  if (
    !portal?.is_allow_access ||
    !access_type ||
    ['Denied', 'Undefined'].includes(access_type)
  ) {
    isMute &&
      console.warn(
        'permission check portal failed: portal.is_allow_access:',
        portal?.is_allow_access,
        '; user_role:',
        portal?.user_role,
        '; user_permission:',
        portal?.user_permission,
        '; portal.permission_profile:',
        JSON.stringify(portal?.permission_profile)
      );
    return false;
  }

  return true;
};

const getUserAccessType = (
  account: Record<string, any>,
  fcName: string
): string => {
  const portal = account?.portals?.find(
    (obj: Record<string, any>) => obj?.app_name === fcName
  );
  const access_type =
    portal?.user_role ||
    portal?.user_permission ||
    portal?.permission_profile?.access_type ||
    '';
  return access_type;
};

export const IsFullAccess = (
  account: Record<string, any>,
  fcName: string
): boolean => {
  const access_type = getUserAccessType(account, fcName);
  return access_type.toLowerCase().includes('admin') ? true : false;
};
